import React, { FC, useEffect, useState } from "react";
import { inject, observer } from "mobx-react";
import { ReactI18NextChild, useTranslation } from "react-i18next";
import { Table, Row, Col } from "reactstrap";
import MyProfileStore from "./store";
import { MessageResultState } from "../../types/general-types";
import { UserInfoDto } from "./types";

interface IPage {
  MyProfileStore?: MyProfileStore;
}

const MyProfilePage: FC<IPage> = inject("MyProfileStore")(
  observer((props: IPage) => {
    const { MyProfileStore: store } = props;
    const { t } = useTranslation();
    const [userInfoDto, setUserInfoDto] = useState<UserInfoDto>();

    useEffect(() => {
      if (store) {
        store.getUserInfos().then((res) => {
          if (res.state === MessageResultState.SUCCESS) {
            setUserInfoDto(res.result);
          }
        });
      }
    }, [store]);

    // Permissions with and without prefix ('_')
    const withPrefix = userInfoDto?.permissions.filter((permission) =>
      permission.includes("_")
    );
    const withoutPrefix = userInfoDto?.permissions.filter(
      (permission) => !permission.includes("_")
    );

    // Prefix'e göre gruplayalım
    const groupedByPrefix = withPrefix?.reduce(
      (acc: any, permission: string) => {
        const prefix = permission.split("_")[0];
        if (!acc[prefix]) {
          acc[prefix] = [];
        }
        acc[prefix].push(permission);
        return acc;
      },
      {}
    );

    return (
      <div className="container-fluid mt-3" style={{ height: "100%" }}>
        <div className="mt-5 text-center">
          <Row>
            <Col
              xs="12"
              sm="4"
              md="3"
              className="d-flex justify-content-center mb-3 mb-md-0"
            >
              <img
                width={250}
                height={250}
                className="rounded-circle"
                src={userInfoDto?.avatar}
                alt={userInfoDto?.name}
              />
            </Col>

            <Col xs="12" sm="8" md="5">
              <div style={{ overflowX: "auto" }}>
                <Table>
                  <tbody>
                    <tr>
                      <td style={{ fontWeight: "bold", textAlign: "left" }}>
                        {t("Name Surname")} :
                      </td>
                      <td style={{ textAlign: "left" }}>{userInfoDto?.name}</td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", textAlign: "left" }}>
                        {t("Username")} :
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {userInfoDto?.username}
                      </td>
                    </tr>
                    <tr>
                      <td
                        style={{
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        {t("Region")} :
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {userInfoDto?.region}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", textAlign: "left" }}>
                        {t("Branch")} :
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {userInfoDto?.branch}
                      </td>
                    </tr>
                    <tr>
                      <td style={{ fontWeight: "bold", textAlign: "left" }}>
                        {t("Position")} :
                      </td>
                      <td style={{ textAlign: "left" }}>
                        {userInfoDto?.position}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Col>

            <Col xs="12" sm="12" md="4" className="mt-3 mt-md-0">
              <h5>{t("Permissions")} : </h5>
              <div className="accordion" id="permissionsAccordion">
                {groupedByPrefix &&
                  Object.keys(groupedByPrefix).map((prefix) => (
                    <div key={prefix} className="accordion-item">
                      <h2 className="accordion-header" id={`heading-${prefix}`}>
                        <button
                          className="accordion-button"
                          style={{
                            backgroundColor: "#f8f9fa",
                            borderColor: "#ddd",
                            color: "#000",
                          }}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#collapse-${prefix}`}
                          aria-expanded="false"
                          aria-controls={`collapse-${prefix}`}
                        >
                          {prefix} {t("Permissions")}
                        </button>
                      </h2>
                      <div
                        id={`collapse-${prefix}`}
                        className="accordion-collapse collapse"
                        aria-labelledby={`heading-${prefix}`}
                        data-bs-parent="#permissionsAccordion"
                      >
                        <div className="accordion-body">
                          {groupedByPrefix[prefix].map(
                            (
                              permission: string,
                              index: React.Key | null | undefined
                            ) => (
                              <span
                                key={index}
                                className="badge rounded-pill bg-secondary me-1 mb-1"
                                style={{ fontWeight: 300 }}
                              >
                                {permission}
                              </span>
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  ))}

                {withoutPrefix && withoutPrefix.length > 0 && (
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingWithoutPrefix">
                      <button
                        className="accordion-button"
                        style={{
                          backgroundColor: "#f8f9fa",
                          borderColor: "#ddd",
                          color: "#000",
                        }} // Add custom style here
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseWithoutPrefix"
                        aria-expanded="false"
                        aria-controls="collapseWithoutPrefix"
                      >
                        {t("Other Permissions")}
                      </button>
                    </h2>
                    <div
                      id="collapseWithoutPrefix"
                      className="accordion-collapse collapse"
                      aria-labelledby="headingWithoutPrefix"
                      data-bs-parent="#permissionsAccordion"
                    >
                      <div className="accordion-body">
                        {withoutPrefix.map((permission, index) => (
                          <span
                            key={index}
                            className="badge rounded-pill bg-secondary me-1 mb-1"
                            style={{ fontWeight: 300 }}
                          >
                            {permission}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  })
);

export default MyProfilePage;
